import { render, staticRenderFns } from "./SalesTable.vue?vue&type=template&id=7bf81b31"
import script from "./SalesTable.ts?vue&type=script&lang=ts&external"
export * from "./SalesTable.ts?vue&type=script&lang=ts&external"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports